// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgu_a bht_bi"};